import AddressFormatter from "@shopify/address"

import { OrderCustomerInfoResult } from "@/api/shopify-graphql/shopify-graphql.type"

type ShippingAddress = NonNullable<NonNullable<OrderCustomerInfoResult["order"]>["shippingAddress"]>

/** app 语言（取不到 Shopify 后台语言时的兜底）与 Shopify 地址服务 locale 不一致的几项，其余同名可直接用 */
const ADDRESS_LOCALE_MAP: Record<string, string> = {
  "zh": "zh-CN",
  "zh-HK": "zh-TW",
  "no": "nb",
}

/**
 * 复制收货地址用：按 Shopify 后台语言排版（不含电话），与 Shopify 复制结果一致：省份、国家用当地语言全称，行序按国家习惯
 * GraphQL 的 formatted 是页面展示格式（英文、省份缩写如 CA），只在地址服务请求失败时兜底
 */
export async function formatShippingAddress(address: ShippingAddress, language: string): Promise<string[]> {
  const fallback = [address.name, ...address.formatted].filter(Boolean) as string[]

  if (!address.countryCodeV2) {
    return fallback
  }

  try {
    const lines = await new AddressFormatter(ADDRESS_LOCALE_MAP[language] || language).format({
      firstName: address.firstName || "",
      lastName: address.lastName || "",
      company: address.company || "",
      address1: address.address1 || "",
      address2: address.address2 || "",
      city: address.city || "",
      province: address.provinceCode || "",
      zip: address.zip || "",
      country: address.countryCodeV2,
    })

    return lines.filter(Boolean)
  } catch {
    return fallback
  }
}
